<template>
    <header class="bg-white p-3 fixed z-40 inset-x-0 top-0 lg:p-0 lg:pt-5">
        <div class="flex w-container lg:w-container-lg md:w-full md:px-5 mx-auto relative xs:flex-col">
            <div class="mr-5 lg:ml-0 lg:absolute xs:static">
                <NuxtLink to="/">
                    <img class="h-32 w-32 lg:hidden" src="/img/logos/cvovolt.png">
                    <img class="h-15 w-32 hidden lg:block" src="/img/logos/cvovolt_rechthoek.png">
                </NuxtLink>
            </div>
            <nav class="flex flex-wrap w-full" :class="nav">
                <Heading class="w-212 lg:w-167 lg:ml-36 lg:-mt-1 md:hidden mr-15 mt-4 text-4xl lg:text-3xl h-12 border-b-2 border-grey-light text-grey-light" :class="heading" />
                <QuickLinks class="w-212 lg:w-203 lg:pl-36 lg:mt-4 md:hidden mr-15 mt-9 " :class="pijlers">
                    <QuickLink to="/cursus-opleiding">cursus | opleiding</QuickLink>
                    <QuickLink to="/studiewijzer">studiewijzer</QuickLink>
                    <QuickLink to="/nt2">Nederlands | Dutch</QuickLink>
                </QuickLinks>
                <QuickLinks class="flex-1 md:w-full lg:mt-4 md:ml-36 xs:hidden mt-9 xs:mt-0">
                    <QuickLink to="/contact">contact</QuickLink>
                    <QuickLink to="https://moodle.cvovolt.be" target="_blank">leerplatform</QuickLink>
                    <QuickLink to="/lokaal">lokaal</QuickLink>
                </QuickLinks>
                <NavBar>
                    <NavbarMobile/>
                    <div class="w-212 mr-15 lg:w-203 md:w-auto md:flex-grow flex text-sm md:mr-5">
                        <NavbarPijler/>
                        <div class="flex pl-4 hover:bg-gray-500 h-full items-center sm:hidden hover:bg-opacity-10" @mouseover="showMegaMenu" @mouseout="hideMegaMenu" @click="toggleMegaMenu">
                            <a class="flex items-center cursor-pointer">
                                aanbod
                                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </a>
                            <span class="pl-4 text-base">|</span>
                            <NavbarAanbodMegaMenu class="bg-white left-0 shadow text-grey-dark pb-4 text-left" :class="mmClass" /> 
                        </div>
                        <NavbarItem class="sm:hidden hover:bg-opacity-10" :to="pathTools.waaromCvoVoltLink()">waarom cvo volt</NavbarItem>
                        <NavbarItem class="sm:hidden hover:bg-opacity-10" :to="pathTools.faqLink()">FAQ</NavbarItem>
                        <NavbarItem class="sm:hidden hover:bg-opacity-10" to="/nieuws/infomomenten">infomomenten</NavbarItem>
                        <NavbarItem class="sm:hidden hover:bg-opacity-10" to="https://mijn.cvovolt.be" target="_blank">mijn cvo volt</NavbarItem>
                        <NavbarItem class="sm:hidden hover:bg-opacity-10" to="https://enlito.be/" target="_blank">B2B Enlito</NavbarItem>
                        <div class="flex-grow" />
                        <NavbarUser />
                        <NavbarCart />
                    </div>                    
                    <NavbarSearch />
                </NavBar>
            </nav>
        </div>
    </header>
</template>

<script setup>
    const pathTools = usePathTools();

    const props = defineProps({
        frontpage: {
            type: Boolean,
            default: false,
        },
    });

    const megaMenuActive = ref(false);

    const nav = computed(() => props.frontpage ? 'mr-4 lg:mr-0 lg:mt-4' : '')
    const heading = computed(() => props.frontpage ? '' : 'hidden')
    const pijlers = computed(() => props.frontpage ? 'hidden' : '')
    const mmClass = computed(() => megaMenuActive.value ? 'mmVisible' : 'mmHidden')

    const showMegaMenu = () => megaMenuActive.value = true;
    const hideMegaMenu = () =>  megaMenuActive.value = false;
    const toggleMegaMenu = () => megaMenuActive.value != megaMenuActive.value;
</script>


<style lang="postcss">
    .mmHidden {
        @apply w-0 overflow-hidden;
    }
    .mmVisible {
        @apply w-full overflow-x-hidden overflow-y-auto;
        max-height: calc(100vh - 170px);
        top: 128px;
    }
    @screen lg {
        .mmVisible {
            max-height: calc(100vh - 170px);
            top: 110px;
        }
    }
</style>